module.exports = __webpack_public_path__ + "img/fr.48ed3d31.svg";